module.exports = __webpack_public_path__ + "static/media/DSA-logged-in-mobile__01.bae49ffe.jpg";